import { CSSObject } from "@emotion/react";
import { theme } from "./theme";

export const globalStyle = {
  "*": {
    boxSizing: "border-box" as CSSObject["boxSizing"],
  },
  body: {
    fontFamily: theme.fontFamily,
    margin: 0,
    width: "100%",
    height: "100%",
  },
  html: {
    fontSize: "100%",
  },
  svg: {
    overflow: "visible",
  },
};
